import { gql } from "@apollo/client";

const schema = {
  create: {
    name: "createShopType",
    serviceName: "admin",
    query: gql`
      mutation createShopType(
        $title: String!
        $details: String
      ) {
        createShopType(
          title: $title
          details: $details
        ) {
          messages
        }
      }
    `,
  },
};

export default schema;
